"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const CircularCountDown_vue_1 = __importDefault(require("./CircularCountDown.vue"));
const Module_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Module"));
let ModalChangeModule = class ModalChangeModule extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.timeCircle = 5;
        this.loadingModule = false;
    }
    onCountDownFinish() {
        this.loadingModule = true;
        const destMod = new Module_1.default({ 'slug': this.moduleChangePayload.destinationModule });
        destMod.setThisAsCurrentModule();
        if (this.moduleChangePayload.url.length > 0) {
            window.location.href = this.moduleChangePayload.url;
        }
    }
    dismissModal() {
        this.$emit('dismissModalTime');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], ModalChangeModule.prototype, "moduleChangePayload", void 0);
ModalChangeModule = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Modal: bmk_ui_framework_1.Modal,
            Chart3: bmk_ui_framework_1.Chart3,
            TrackingLogo: bmk_ui_framework_1.TrackingLogo,
            ChevronsRight: lucide_vue_next_1.ChevronsRight,
            CircularCountDown: CircularCountDown_vue_1.default,
            ResultsLogo: bmk_ui_framework_1.ResultsLogo,
            PlannerLogo: bmk_ui_framework_1.PlannerLogo,
            Button: bmk_ui_framework_1.Button,
        },
    })
], ModalChangeModule);
exports.default = ModalChangeModule;
